import React from "react";
import { Switch, Route } from "react-router-dom";
import DesignV1 from "../designs/v1";
import PreviewV1 from "../preview/v1";
import DigilockerDetails from "../designs/v1/pages/DigilockerDetails";
import ReKycDigilockerDetails from "../designs/v1/pages/ModifyKyc/pages/ReKycDigilockerDetails";
import EsignDocument from "../designs/v1/pages/EsignDocument";
import DetectBroker from "./DetectBroker";
import DetectReferalCode from "./DetectReferalCode";
import DetectPromoCode from "./DetectPromoCode";
import ValidatePan from "../designs/v1/pages/ValidatePan";
import CloseKyc from "../designs/v1/pages/CloseKyc";
import ModifyKyc from "../designs/v1/pages/ModifyKyc";
import DetectBrokerMoveDevice from "./DetectBrokerMoveDevice";
import DetectBrokerRekycMoveDevice from "./DetectBrokerRekycMoveDevice";
// kyc routes
import KycRoutes from "./KycRoutes";

const Routers = () => {
  return (
    <Switch>
      <Route
        exact
        path="/"
        component={DesignV1}
      />
      <Route
        exact
        path="/preview/:name/:page"
        component={PreviewV1}
      />
      <Route
        exact
        path="/detectBroker/:brokerID"
        component={DetectBroker}
      />
      <Route
        exact
        path="/d/:brokerID"
        component={DetectBroker}
      />
      <Route
        exact
        path="/d/:brokerID/:token"
        component={DetectBrokerMoveDevice}
      />
      <Route
        exact
        path="/m/:brokerID/:token/:docName"
        component={DetectBrokerRekycMoveDevice}
      />

      <Route
        exact
        path="/c/:brokerID"
        component={DetectBroker}
      />
      <Route
        exact
        path="/m/:brokerID"
        component={DetectBroker}
      />
      <Route
        exact
        path="/detectReferal/:brokerID/:referalID"
        component={DetectReferalCode}
      />
      <Route
        exact
        path="/detectPromoCode/:brokerID/:promoCode"
        component={DetectPromoCode}
      />
      <Route
        exact
        path="/close-kyc/:brokerID"
        component={CloseKyc}
      />
      <Route
        exact
        path="/modify-kyc/:brokerID"
        component={ModifyKyc}
      />
      <Route
        exact
        path="/digilockerDetails"
        component={DigilockerDetails}
      />
      <Route
        exact
        path="/rekyc-digilocker-details"
        component={ReKycDigilockerDetails}
      />
      <Route
        exact
        path="/getEsignDocument"
        component={EsignDocument}
      />
      <Route
        exact
        path="/validate-pan"
        component={ValidatePan}
      />
      <KycRoutes />
    </Switch>
  );
};

export default Routers;
